
import React, { Component } from 'react';
import { render } from 'react-dom';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { ColorPicker } from 'office-ui-fabric-react/lib/ColorPicker';
import { getColorFromString, getColorFromRGBA } from 'office-ui-fabric-react/lib';

let resolve;

class DialogColor extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogColor/>, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            message: ''
        };
    }

    getColorObject(colorText) {
        let arr = (colorText || '').split(' ');
        if (arr.length >= 3) {
            return getColorFromRGBA({
                r: parseInt(arr[0]),
                g: parseInt(arr[1]),
                b: parseInt(arr[2])
            })
        } else {
            return getColorFromString('#000000')
        }
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(false);
    }

    handleConfirm = () => {
        this.setState({hidden: true});
        resolve(this.state.color);
    }

    handleChange = (event, color) => {
        this.setState({color: `${color.r} ${color.g} ${color.b}`})
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    type: DialogType.normal
                }}
                modalProps={{
                    isBlocking: false
                }}
                >

                <ColorPicker
                    color={this.getColorObject(this.state.color)}
                    onChange={this.handleChange}
                    alphaType="none"
                    showPreview={true}
                    strings={{
                        'red': 'Červená',
                        'green': 'Zelená',
                        'blue': 'Modrá'
                    }}
                />

                <DialogFooter>
                    <PrimaryButton onClick={this.handleConfirm} text="Ok" />
                    <DefaultButton onClick={this.handleCancel} text="Zrušit" />
                </DialogFooter>
            </Dialog>
        );
    }

    show(color, options) {
        this.setState({
            hidden: false,
            color: color,
            options: options
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogColor.create();
